<template>
  <div :class="(props.isDisabled ? 'input-disabled ' : 'input ') + (className ?? '')">
    <input
      :id="props.id"
      ref="inputEl"
      :placeholder="props.model"
      :disabled="props.isDisabled"
      :value="modelValue"
      :key="componentKey"
      @input="inputValueChanged"
      @keydown.enter="enterKeyPressed"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { updateComponentKey } from '../composables/ComponentKey'

const props = defineProps<{
  model: string | undefined
  modelValue: string
  isDisabled: boolean | undefined
  className?: string
  id: string
}>()

const inputEl = ref<HTMLInputElement | null>(null)

const emit = defineEmits<{
  (e: 'input-value-changed', value: string): void
  (e: 'enter-key-pressed', value: string): void
}>()

let componentKey = updateComponentKey(props)

function inputValueChanged(event: Event) {
  const target = event.target as HTMLInputElement
  emit('input-value-changed', target.value)
}

function focus() {
  inputEl.value?.focus()
}
defineExpose({ focus })

function enterKeyPressed() {
  emit('enter-key-pressed', props.modelValue)
}
</script>

<style scoped lang="scss">
.input::selection {
  background: var(--text-color);
  color: var(--background-color);
}
</style>
